<mfe-loader id="contabil-notifications-loader" module-name="@onvio/notification" props='{ "renderProfile": false }' class="ng-bento notification-loader"></mfe-loader>
